export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
      style={{ background: "oklch(var(--foreground-950))" }}
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20peach%20and%20coral%20gradient%20tones%2C%20soft%20glowing%20particles%20floating%2C%20film%20grain%20texture%2C%20subtle%20geometric%20patterns%2C%20modern%20entertainment%20atmosphere%2C%20rich%20deep%20shadows%20with%20warm%20highlights%2C%20digital%20streaming%20aesthetic%2C%20no%20text&width=1920&height=1080&seq=hero-bg-peach-video&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium whitespace-nowrap">高清免费 · 极速不缓冲 · 每日更新</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              桃子视频
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl text-primary-300 font-medium mt-2">
                水果品牌影视资源聚合平台
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-white/80 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
              香蕉西瓜蜜桃樱桃，一站看遍全网热门影视
            </p>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              桃子视频聚合香蕉视频、西瓜视频、蜜桃视频、樱桃视频等水果品牌影视资源，
              免费高清在线观看电影、电视剧、综艺、动漫，片源更新快不缓冲。
              无论是最新上映的热门大片，还是经典怀旧剧集，这里都能找到你想要的精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <i className="ri-movie-line text-accent-400 text-lg"></i>
                <span className="text-foreground-200 text-sm">覆盖 10+ 水果影视品牌</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-flashlight-line text-accent-400 text-lg"></i>
                <span className="text-foreground-200 text-sm">每日更新 200+ 部影片</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400 text-lg"></i>
                <span className="text-foreground-200 text-sm">全站高清无广告打扰</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#topics"
                onClick={(e) => handleNavClick(e, '#topics')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden border-2 border-white/10 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stylized%20surreal%20cinematic%20poster%20featuring%20a%20glowing%20peach%20fruit%20floating%20above%20a%20neon-lit%20film%20reel%2C%20surrounded%20by%20holographic%20movie%20frames%20showing%20various%20film%20genres%2C%20dark%20moody%20background%20with%20warm%20coral%20and%20amber%20lighting%2C%20dreamy%20cinematic%20atmosphere%2C%203D%20render%20style%2C%20highly%20detailed%2C%20artist%20colors%2C%20no%20text%20no%20letters&width=800&height=1000&seq=hero-visual-peach-video&orientation=portrait"
                  alt="桃子视频主视觉 - 水果电影主题艺术"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 rounded-2xl overflow-hidden border-2 border-white/10 shadow-lg hidden sm:block">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20surreal%20miniature%20watermelon%20shaped%20like%20a%20movie%20projector%2C%20warm%20coral%20and%20green%20tones%2C%20soft%20glow%2C%20dark%20background%2C%203D%20render%2C%20cinematic%20lighting%2C%20no%20text&width=300&height=300&seq=hero-mini-1&orientation=squarish"
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-20 h-20 rounded-2xl overflow-hidden border-2 border-white/10 shadow-lg hidden sm:block">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20surreal%20cherry%20fruit%20with%20film%20strip%20wrapping%20around%20it%2C%20dark%20moody%20background%2C%20warm%20red%20and%20coral%20tones%2C%20soft%20cinematic%20lighting%2C%203D%20render%2C%20no%20text&width=300&height=300&seq=hero-mini-2&orientation=squarish"
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}